import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { TEAM_MEMBERS_LIST, TEAM_MEMBERS_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: { list: request_state(), create: request_state(), remove: request_state() },
    mutations: {
        ...request_mutations('team_members_list', 'list'),
        ...request_mutations('create_team_member', 'create'),
        ...request_mutations('remove_team_member', 'remove'),
    },
    actions: {
        list({ commit }, params) {
            commit('team_members_list_loading');
            axios.get(TEAM_MEMBERS_LIST, { params, ...auth() })
                .then(response => commit('team_members_list_success', response.data))
                .catch(error => commit('team_members_list_error', error.response ? error.response.data : {}));
        },
        create({ commit }, data) {
            commit('create_team_member_loading');
            return new Promise((resolve) => {
                axios.post(TEAM_MEMBERS_LIST, data, auth()).then((response) => {
                    commit('create_team_member_success', response.data);
                    resolve();
                }).catch(error => commit('create_team_member_error', error.response ? error.response.data : {}));
            });
        },
        remove({ commit }, { id }) {
            commit('remove_team_member_loading');
            return new Promise((resolve) => {
                axios.delete(TEAM_MEMBERS_DETAIL.replace('{id}', id), auth()).then((response) => {
                    commit('remove_team_member_success', response.data);
                    resolve();
                }).catch(error => commit('remove_team_member_error', error.response ? error.response.data : {}));
            });
        },
    },
};
